let profession = {
  content: '',
  table: [
    { type: 'AN', 年限: '', 固薪: '', 奖金: '' },
    { type: 'Asso', 年限: '', 固薪: '', 奖金: '' },
    { type: 'SA', 年限: '', 固薪: '', 奖金: '' },
    { type: 'AVP', 年限: '', 固薪: '', 奖金: '' },
    { type: 'VP', 年限: '', 固薪: '', 奖金: '' },
    { type: 'SVP', 年限: '', 固薪: '', 奖金: '' },
    { type: 'AD', 年限: '', 固薪: '', 奖金: '' },
    { type: 'D', 年限: '', 固薪: '', 奖金: '' },
    { type: 'ED', 年限: '', 固薪: '', 奖金: '' },
    { type: 'MD', 年限: '', 固薪: '', 奖金: '' },
  ],
}
let manage = {
  content: '',
  table: [
    { type: '专员', 年限: '', 固薪: '', 奖金: '' },
    { type: '主管', 年限: '', 固薪: '', 奖金: '' },
    { type: '经理', 年限: '', 固薪: '', 奖金: '' },
    { type: '副总监', 年限: '', 固薪: '', 奖金: '' },
    { type: '总监', 年限: '', 固薪: '', 奖金: '' },
    { type: '部门总助', 年限: '', 固薪: '', 奖金: '' },
    { type: '部门副总', 年限: '', 固薪: '', 奖金: '' },
    { type: '部门总', 年限: '', 固薪: '', 奖金: '' },
    { type: '公司总助', 年限: '', 固薪: '', 奖金: '' },
    { type: '公司副总', 年限: '', 固薪: '', 奖金: '' },
    { type: '公司总经理', 年限: '', 固薪: '', 奖金: '' },
    { type: '总裁', 年限: '', 固薪: '', 奖金: '' },
    { type: '董事长', 年限: '', 固薪: '', 奖金: '' },
  ],
}
const moneyTable = [
  { 专业职级: '', 管理职级: '', 指标: '', 年限: '', 固薪: '', 奖金: '' },
  { 专业职级: '', 管理职级: '', 指标: '', 年限: '', 固薪: '', 奖金: '' },
  { 专业职级: '', 管理职级: '', 指标: '', 年限: '', 固薪: '', 奖金: '' },
  { 专业职级: '', 管理职级: '', 指标: '', 年限: '', 固薪: '', 奖金: '' },
  { 专业职级: '', 管理职级: '', 指标: '', 年限: '', 固薪: '', 奖金: '' },
  { 专业职级: '', 管理职级: '', 指标: '', 年限: '', 固薪: '', 奖金: '' },
  { 专业职级: '', 管理职级: '', 指标: '', 年限: '', 固薪: '', 奖金: '' },
  { 专业职级: '', 管理职级: '', 指标: '', 年限: '', 固薪: '', 奖金: '' },
  { 专业职级: '', 管理职级: '', 指标: '', 年限: '', 固薪: '', 奖金: '' },
  { 专业职级: '', 管理职级: '', 指标: '', 年限: '', 固薪: '', 奖金: '' },
]
const moneyContent = {
  奖金机制: '',
  考核指标: '',
  奖金发放时间: '',
  递延机制: '',
  备注: '',
}
export { profession, manage, moneyTable, moneyContent }
